export default "__VITE_ASSET__BWcncGFV__"